<template>
  <DownloadsComponent :error-message="errorMessage" :keycode="keycode" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DownloadsComponent from "@/components/Downloads/Downloads.vue";

const componentName = "DownloadsRoute";

export default defineComponent({
  name: componentName,
  components: { DownloadsComponent },
  props: {
    errorMessage: {
      type: String,
      required: false,
      default: null,
    },
    keycode: {
      type: String,
      required: false,
      default: null,
    },
  },
});
</script>
